import { useMemo } from "react";
import {
  InternalAdminUserAttributeCategoryListInput,
  InternalAdminUserAttributeCategoryListQuery,
  InternalAdminUserAttributeCategoryListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_LIST_QUERY from "../_networking/internal-admin-user-attribute-category-list";

interface IProps {
  organizationId?: string;
  input: InternalAdminUserAttributeCategoryListInput;
}

const useInternalAdminUserAttributeCategoryList = ({
  organizationId,
  input,
}: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminUserAttributeCategoryListQuery,
    InternalAdminUserAttributeCategoryListQueryVariables
  >(INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const userAttributeCategories = useMemo(() => {
    if (!data) return [];
    return data.internalAdminUserAttributeCategoryList;
  }, [data]);

  return {
    userAttributeCategories,
    loading,
    refetch,
  };
};

export default useInternalAdminUserAttributeCategoryList;
